import { Button } from 'react-bootstrap';
import {
  gearIcon,
  pdfIcon,
  chevronUpIcon,
  chevronDownIcon,
} from '../../../helpers/icons';
import officialscoresheetStyles from '../../officialscoresheet.module.css';

const {
  scoreSheetSetupButton,
  scoreSheetPrintButton,
  scoreSheetUpButton,
  scoreSheetDownButton,
  scrollShadow,
} = officialscoresheetStyles;

export function ScrollShadow({ pct }) {
  return <div className={scrollShadow} style={{ width: `${pct}%` }}></div>;
}

export function ScoreSheetSetupButton({ handler }) {
  return (
    <div className={scoreSheetSetupButton}>
      <Button variant="outline-secondary" onClick={handler}>
        {gearIcon}
      </Button>
    </div>
  );
}

export function ScoreSheetPrintButton({ handler }) {
  return (
    <div className={scoreSheetPrintButton}>
      <Button variant="outline-secondary" onClick={handler}>
        {pdfIcon}
      </Button>
    </div>
  );
}

export function ScoreSheetPrevButton({ disabled, handler }) {
  return (
    <div className={scoreSheetUpButton}>
      <Button disabled={disabled} variant="outline-secondary" onClick={handler}>
        {chevronUpIcon}
      </Button>
    </div>
  );
}

export function ScoreSheetNextButton({ disabled, handler }) {
  return (
    <div className={scoreSheetDownButton}>
      <Button disabled={disabled} variant="outline-secondary" onClick={handler}>
        {chevronDownIcon}
      </Button>
    </div>
  );
}
